import { Tooltip, TooltipProps, Typography, TypographyProps } from '@mui/material'
import { FC, useState, MouseEvent } from 'react'

export interface TooltipTypographyProps extends Omit<TypographyProps, 'onMouseEnter'> {
  tooltipProps?: Omit<TooltipProps, 'title' | 'children'>
}

/**
 * This component will conditionally show a tooltip on a Typography only if the text is overflowed.
 */
export const TooltipTypography: FC<TooltipTypographyProps> = ({ tooltipProps = {}, ...props }) => {
  const [tooltipEnabled, setTooltipEnabled] = useState(false)

  const handleMouseEnter = ({ currentTarget }: MouseEvent) => {
    if (currentTarget.scrollWidth > currentTarget.clientWidth) {
      setTooltipEnabled(true)
    } else {
      setTooltipEnabled(false)
    }
  }

  return tooltipEnabled ? (
    <Tooltip {...tooltipProps} title={props.children}>
      <Typography {...props} onMouseEnter={handleMouseEnter} />
    </Tooltip>
  ) : (
    <Typography {...props} onMouseEnter={handleMouseEnter} />
  )
}
